import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

export default class extends Controller {
  initialize() {}

  connect() {
    this.initialized = true;

    useMatchMedia(this, {
      mediaQueries: {
        desktopLayout: '(min-width: 1024px)',
      },
    });
  }

  static targets = [
    'drawer',
    'bg',
    'toggle',
    'opendrawer',
    'closedrawer',
  ];

  static values = {
    draweractive: Boolean,
  };

  toggle() {
    this.toggleContent();
    this.toggleOverlayBg();
    this.toggleOpenCloseIcons();
    this.setActiveValue();
    this.setAriaLabels();
  }

  setActiveValue() {
    this.draweractiveValue = !this.draweractiveValue;
  }

  toggleContent() {
    this.drawerTarget.classList.toggle(
      'translate-x-full',
      this.draweractiveValue
    );
  }

  toggleOverlayBg() {
    this.bgTarget.classList.toggle(
      'opacity-50',
      !this.draweractiveValue
    );
    this.bgTarget.classList.toggle(
      'opacity-0',
      this.draweractiveValue
    );
    this.bgTarget.classList.toggle('hidden', this.draweractiveValue);
  }

  toggleOpenCloseIcons() {
    this.opendrawerTarget.classList.toggle(
      'hidden',
      !this.draweractiveValue
    );
    this.closedrawerTarget.classList.toggle(
      'flex',
      !this.draweractiveValue
    );
    this.closedrawerTarget.classList.toggle(
      'hidden',
      this.draweractiveValue
    );
  }

  close() {
    this.drawerTarget.classList.add('translate-x-full');
    this.bgTarget.classList.remove('opacity-50');
    this.bgTarget.classList.add('opacity-0', 'hidden');
    this.opendrawerTarget.classList.remove('hidden');
    this.closedrawerTarget.classList.remove('flex');
    this.closedrawerTarget.classList.add('hidden');
  }

  setAriaLabels() {
    this.drawerTarget.setAttribute(
      'aria-expanded',
      this.draweractiveValue ? true : false
    );
    this.bgTarget.setAttribute(
      'aria-hidden',
      !this.draweractiveValue ? true : false
    );
  }

  desktopLayoutChanged({ matches }) {
    this.draweractiveValue = matches ? true : false;
    if (!this.draweractiveValue) {
      this.close();
    }
    this.setAriaLabels();
  }

  isDesktopLayout({ matches }) {
    this.draweractiveValue = true;
    this.setAriaLabels();
    this.bgTarget.setAttribute('aria-hidden', true);
  }
}
